import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { ClaimsDataService } from '../../../../../_services/_claims/claims-data.service';
import { CompanyTypeService } from '../../../../../_services/_iam/company-type.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-cliams-nav',
  templateUrl: './cliams-nav.component.html'
})
export class CliamsNavComponent implements OnInit {
  @Input() claimId: string;
  company: string;
  claim: any;

  constructor(private claimsDataService: ClaimsDataService,
              private companyTypeService: CompanyTypeService) { }

  ngOnInit(): void {
    this.claimsDataService.$claimsLossDetails
    .subscribe( (claimsList) => {
      if(claimsList) {
        claimsList.forEach(claim => {
          if(claim.number.number === this.claimId) {
            this.claim = claim;
            this.company = this.companyTypeService.getCompany(claim.policyNumber.policyNumber) ;
          }
        });
      }

  })
  }

}
